export default {
	title: 'Stakeholders',
	context_best: 'Favorable',
	context_worse: 'Hostile',
	zones: {
		positive: 'Favorable',
		positive_line2: 'Zone',
		neutral: 'Neutral',
		negative: 'Hostile',
		negative_line2: 'Zone',
		point_of_view_line1: 'Point',
		point_of_view_line2: 'of',
		point_of_view_line3: 'View'
	},
	alignment: {
		title_1: 'Stakeholder',
		title_2: 'alignment'
	},
	tabs: {
		general: {
			title: 'General'
		},
		links: {
			title: 'Links'
		},
		comments: {
			title: 'History'
		},
		filters: {
			title: 'View filters'
		},
		export: {
			title: 'Export',
			image: 'Export radar as image'
		},
		risks: {
			title: 'Risks'
		},
		bot: {
			title: 'AI'
		},
		tags: {
			title: 'Tags',
			assigned: 'Assigned tags',
			unassigned: 'Unassigned tags'
		},
		disabled: {
			title: 'Disabled'
		}
	},
	summary: {
		key_drivers: 'Key drivers',
		scenario_score: 'Scenario score',
		max_value: 'max {{value}}',
		legend: {
			current: 'Current',
			scenario: 'Scenario'
		}
	},
	all_tags: 'Tags filter',
	links: 'Display all links',
	no_tag: 'No tag',

	all_icons: 'Icons filter',
	no_icon: 'No icon',

	all_stakes: 'Stakes filter',
	all_constraints: 'Indicators filter',
	all_risks: 'Risks filter',
	all_opportunities: 'Openings filter',

	onboarding: {
		title: 'Review your stakeholders',
		description:
			"The actors that weigh on your topic are positioned on the radar by their influence and stance. Check the alignment and adjust if your reading differs."
	}
};
